import React from "react";
import { RiLockLine } from "react-icons/ri";
import ButtonComponent from "../ButtonComponent/ButtonComponent";
import "./BlockDisplayComponent.scss";

const BlockDisplayComponent = ({
    title = "This feature is locked",
    description = "Premium users can access it only when this add-on has been added to their package. Call 070 536 7980 to get this feature",
    primaryButtonText = "Unlock Feature",
    secondaryButtonText = "Go Back",
    onPrimaryClick,
    onSecondaryClick,
    className = "",
}) => {
    return (
        <section className={`blockDisplay ${className}`.trim()}>
            <div className="blockDisplay__card">
                <div className="blockDisplay__iconWrap">
                    <RiLockLine className="blockDisplay__icon" />
                </div>

                <div className="blockDisplay__content">
                    <h2 className="blockDisplay__title">{title}</h2>
                    <p className="blockDisplay__description">{description}</p>
                </div>

                {/* <div className="blockDisplay__actions">
          <ButtonComponent
            as="button"
            className="blockDisplay__primaryBtn"
            onClick={onPrimaryClick}
          >
            {primaryButtonText}
          </ButtonComponent>

          <ButtonComponent
            as="button"
            className="blockDisplay__secondaryBtn"
            onClick={onSecondaryClick}
          >
            {secondaryButtonText}
          </ButtonComponent>
        </div> */}
            </div>
        </section>
    );
};

export default BlockDisplayComponent;